var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loader},[_c('span',{class:_vm.$style.inner}),_vm._v("\n  正在加载中...\n")])}
var staticRenderFns = []

export { render, staticRenderFns }